/* Extracted 2026-10-13 from snippets/tlc-sticky-atc.liquid (inline block 1) — SEO round 3 step 3, audit C1. Loaded at the same position, synchronously. Edit here; the Liquid file only references it. */
(function(){
  var bar=document.getElementById('tlc-satc');if(!bar)return;
  var addBtn=document.getElementById('tlc-satc-add');
  var buyBtn=document.getElementById('tlc-satc-buy');
  var shown=false,ticking=false;
  var onProductPage=document.body.classList.contains('template-product');
  var pform=null;
  /* Product cards render hidden 0x0 quick-add forms for OTHER products, and
     querySelector returns the first one in the DOM. A 0x0 rect reports bottom:0,
     so pastBuyBox stayed true forever and submitting it added the wrong variant.
     Always take the first form that actually renders. */
  function buyForm(){
    if(pform&&pform.isConnected&&pform.offsetParent!==null)return pform;
    var fs=document.querySelectorAll('form[action*="/cart/add"]');
    for(var i=0;i<fs.length;i++){
      if(fs[i].offsetParent!==null&&fs[i].getBoundingClientRect().height>0){pform=fs[i];return pform;}
    }
    return null;
  }

  function update(){
    ticking=false;
    var y=window.pageYOffset,vh=window.innerHeight,dh=document.documentElement.scrollHeight;
    var nearFooter=(y+vh)>(dh-180);
    /* TLC 2026-08-31: the old rule revealed the bar only once the in-page buy form had
       scrolled ABOVE the fold (`bottom < 72`). On PDPs whose Add-to-bag sits low that left
       a long dead zone with no buy affordance at all — measured 1,482px on
       /products/bacne-warrior-acne-fighting-body-spray, the site's #1 paid landing page,
       i.e. ~1.8 mobile viewports of scrolling before anything could be added to the bag.

       Now: reveal after 200px of scroll, and hide only while the real Add-to-bag is
       genuinely on screen. That keeps the original guarantee (never two visible CTAs)
       and removes the dead zone. Pages whose ATC is already above the fold behave
       exactly as before.

       ROLLBACK: restore
         var pastBuyBox=true,pf=buyForm();
         if(pf){pastBuyBox=pf.getBoundingClientRect().bottom<72;}
         var show=onProductPage ? (pastBuyBox && !nearFooter) : (y>vh*0.45 && !nearFooter);
       Elsewhere (non-product pages): after 45% scroll, unchanged. */
    /* TLC 2026-09-02: measure the Add-to-bag BUTTON, not the whole form. On the fragrance
       (kyoto) template the form wraps the size selector as well and is 290px tall, so gating
       on the form's bottom kept this bar hidden until 1,400px of scroll — the very dead zone
       the 2026-08-31 fix removed for ACTIVE+, still live on ~170 fragrance PDPs. Measured on
       /products/oudh-black-rose-body-wash: hidden at y=200/400/900, first shown at y=1400.
       ROLLBACK: var pr=pf.getBoundingClientRect(); */
    var atcOnScreen=false,pf=buyForm();
    if(pf){
      var btn=pf.querySelector('[name="add"],button[type="submit"]')||pf;
      var pr=btn.getBoundingClientRect();
      /* FULLY visible, not merely intersecting. The old test counted a button clipped to its
         last 22px as "on screen" and suppressed this bar: on kyoto the button spans 822-878
         in an 844 viewport, so at rest 96% of it is below the fold and neither CTA was
         usable. Requiring the whole button inside the viewport means the sticky bar covers
         exactly the range where the real one cannot be tapped. */
      atcOnScreen=(pr.top>72 && pr.bottom<=vh-8);
    }
    var show=onProductPage ? (y>200 && !atcOnScreen && !nearFooter) : (y>vh*0.45 && !nearFooter);
    if(show!==shown){shown=show;bar.classList.toggle('is-show',show);document.body.classList.toggle('tlc-satc-on',show);}
  }
  function onScroll(){if(!ticking){ticking=true;requestAnimationFrame(update);}}
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll,{passive:true});
  update();

  function getVid(){
    /* prefer the variant the user selected on the PDP */
    var sel=document.querySelector('input[name="id"]:checked,select[name="id"]');
    if(sel)return sel.value;
    if(addBtn)return addBtn.getAttribute('data-vid');
    if(buyBtn)return buyBtn.getAttribute('data-vid');
  }

  /* ADD TO CART — submit page form → opens cart drawer */
  if(addBtn){
    addBtn.addEventListener('click',function(){
      addBtn.disabled=true;addBtn.classList.add('is-busy');
      var form=buyForm();
      if(form){try{form.requestSubmit?form.requestSubmit():form.submit();setTimeout(function(){addBtn.disabled=false;addBtn.classList.remove('is-busy');},1200);return;}catch(e){}}
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:getVid(),quantity:1})})
        .then(function(r){return r.ok?r.json():Promise.reject();})
        .then(function(){document.dispatchEvent(new CustomEvent('cart:refresh'));addBtn.disabled=false;addBtn.classList.remove('is-busy');var t=document.querySelector('[data-cart-toggle],[aria-controls="cart-drawer"]');if(t)t.click();})
        .catch(function(){addBtn.disabled=false;addBtn.classList.remove('is-busy');});
    });
  }

  /* BUY NOW — add to cart then go straight to checkout */
  if(buyBtn){
    buyBtn.addEventListener('click',function(){
      buyBtn.disabled=true;buyBtn.classList.add('is-busy');
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:getVid(),quantity:1})})
        .then(function(r){return r.ok?r.json():Promise.reject();})
        .then(function(){window.location.href='/checkout';})
        .catch(function(){buyBtn.disabled=false;buyBtn.classList.remove('is-busy');});
    });
  }
})();
